import { render, staticRenderFns } from "./newsletterLinkParses.vue?vue&type=template&id=67fb5088&scoped=true&"
import script from "./newsletterLinkParses.vue?vue&type=script&lang=js&"
export * from "./newsletterLinkParses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67fb5088",
  null
  
)

export default component.exports